import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

type ContentLine = string | string[];

interface OverviewConfigProps {
    heading: string;
    content: {
        heading: string;
        lines: ContentLine[];
    }[];
}

function h2(heading: string) {
    return `<p><strong>${heading}</strong></p>`;
}

function formatContent(lines: ContentLine[]) {
    let html = "<p>";

    for (const line of lines) {
        if (Array.isArray(line)) {
            html += `
  <ul><li>${line.join("</li><li>")}</li></ul>`;
        } else {
            html += line;
        }
    }

    html += "</p>";

    return html;
}

export function overviewConfig({
    heading,
    content,
}: OverviewConfigProps): PageConfig[] {
    let html = `
<h3>${heading}</h3>
<div>
  `;

    for (const section of content) {
        html += h2(section.heading) + formatContent(section.lines);
    }

    html += "</div>";

    return [
        {
            name: "guidelines",
            elements: [
                {
                    type: "html",
                    html,
                },
            ],
        },
    ];
}
